import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { orderAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { REFUND_CLOSING_SOON_DAYS } from '../../utils/refundTimeline';
import { isRefundPending } from '../../utils/refundTimeline';

const MediatorPanelAlerts = () => {
  const { mediatorId } = useAuth();
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const medId = mediatorId || JSON.parse(localStorage.getItem('mediatorData') || '{}')?.id;
    if (!medId) return;

    const load = async () => {
      try {
        const response = await orderAPI.searchOrders({
          page: 0,
          size: 100,
          mediatorId: medId,
          sortBy: 'creationDate',
          sortDirection: 'DESC',
        });
        const orders = response.data?.data || [];
        const next = [];

        orders.forEach((order) => {
          const status = order.orderStatus;
          const timeline = order.refundTimeline;

          if (['REJECTED', 'ORDER_FORM_REFILL_REQUEST', 'REFUND_FORM_REFILL_REQUEST', 'REJECT_AND_REFILL'].includes(status)) {
            const labels = {
              REJECTED: 'Order rejected',
              ORDER_FORM_REFILL_REQUEST: 'Order form refill requested',
              REFUND_FORM_REFILL_REQUEST: 'Refund form refill requested',
              REJECT_AND_REFILL: 'Reject and refill — buyer must refill refund form',
            };
            next.push({
              id: `action-${order.id}`,
              type: status === 'REJECTED' ? 'danger' : 'warning',
              title: `${labels[status]} — ${order.orderId}`,
              message: order.reason ? `Reason: ${order.reason}` : 'Buyer action may be required.',
              link: '/mediator/orders',
            });
          }

          if (isRefundPending(status) && timeline?.refundFormOpen) {
            const daysLeft = timeline.daysLeftToClose;
            if (daysLeft != null && daysLeft > 0 && daysLeft <= REFUND_CLOSING_SOON_DAYS) {
              next.push({
                id: `closing-${order.id}`,
                type: 'danger',
                title: `Refund form closing soon — ${order.orderId}`,
                message: `Buyer has not filled refund form. ${daysLeft} day(s) left before it closes.`,
              });
            }
          }
        });

        setAlerts(next.slice(0, 8));
      } catch {
        setAlerts([]);
      }
    };

    load();
  }, [mediatorId]);

  if (alerts.length === 0) return null;

  const styles = {
    danger: { bg: '#fef2f2', border: '#fecaca', color: '#991b1b', icon: 'alert-circle' },
    warning: { bg: '#fffbeb', border: '#fde68a', color: '#92400e', icon: 'alert-triangle' },
  };

  return (
    <div style={{ padding: '12px 24px 0', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {alerts.map((alert) => {
        const style = styles[alert.type] || styles.warning;
        return (
          <div
            key={alert.id}
            style={{
              padding: '14px 18px',
              borderRadius: '12px',
              background: style.bg,
              border: `1px solid ${style.border}`,
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
            }}
          >
            <Icon name={style.icon} size={22} color={style.color} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: '14px', color: style.color }}>{alert.title}</div>
              <div style={{ fontSize: '13px', color: style.color, marginTop: '4px', opacity: 0.9 }}>{alert.message}</div>
            </div>
          </div>
        );
      })}
      <Link
        to="/mediator/orders"
        style={{ fontSize: '13px', fontWeight: 600, color: '#2563eb', paddingLeft: '4px' }}
      >
        View all orders →
      </Link>
    </div>
  );
};

export default MediatorPanelAlerts;
